export const layoutTwoStyles = (extraCustomCSS: string) => {
  const style = getComputedStyle(document.body)
  const bgColor = style.getPropertyValue('--layout-two-main-bg')
  const bgText = style.getPropertyValue('--text-on-layout-two-bg')
  const checkoutText = style.getPropertyValue('--checkout-bg-text')
  const themedCashierWithTabs = `
    ${extraCustomCSS}
    .tabs {
      background: ${bgColor};
      height: 60px!important;
      top: 0px!important;
    }
    h3.tab {
      color: ${bgText}!important;
      font-size: 18px!important;
      padding: 10px;
    }
    .tabs .tab.active[data-v-1c3ab94f]:after {
      background: ${bgText};
      visibility: hidden;
    }
  `
  return {
    themedCashierWithTabs,
    bgColor,
    bgText,
    checkoutText
  }
}
